import folder from '../../common/folder';
import formatDate from '../../assets/formatDate';
import formatBytes from '../../assets/formatBytes';
import { getNestedFolders } from '../../assets/fileTree';
import file from '../../common/file';
import { systemFolders } from '../FileSystem';
import apiUrl from '../../assets/apiUrl';
import { Menu, MenuItem } from '@material-ui/core';
import { useContext, useState } from 'react';
import ConfirmDialog from '../ConfirmDialog';
import AuthContext, { getAccessToken } from '../Auth';

interface Props {
    folder: folder;
    onOpen: (folder_uid: string) => void;
    onDelete: (folder_uid: string) => void;
    size: any;
    lastUpdated: Date;
    zipFolder: (folder_uid: string) => void;
    allFolders: folder[];
    allFiles: file[];
    onMove: (folder_uid: string) => void;
    openPropertiesViewer: () => void;
}

const Folder: React.FC<Props> = ({
    folder,
    onOpen,
    onDelete,
    size,
    lastUpdated,
    zipFolder,
    allFolders,
    allFiles,
    onMove,
    openPropertiesViewer,
}) => {
    const { fetchWrapper } = useContext(AuthContext);
    const deleteFolder = async (folder_uid: string) => {
        const token = await getAccessToken();
        await fetchWrapper(`${apiUrl}/folder/${folder_uid}`, {
            method: 'DELETE',
            headers: { 'x-access-token': token },
        });
        onDelete(folder_uid);
    };
    const findSize = () => {
        const nestedFolders = getNestedFolders(
            folder.folder_uid,
            allFolders
        ).map((e) => e.folder_uid);
        nestedFolders.push(folder.folder_uid);
        return allFiles
            .filter((e) => nestedFolders.includes(e.folder_uid!))
            .map((e) => parseInt(e.size))
            .reduce((a, b) => a + b, 0);
    };
    const findLastUpdated = () => {
        const nestedFolders = getNestedFolders(
            folder.folder_uid,
            allFolders
        ).map((e) => e.folder_uid);
        nestedFolders.push(folder.folder_uid);
        const dates = allFiles
            .filter((e) => nestedFolders.includes(e.folder_uid!))
            .map((e) => Math.floor(new Date(e.last_updated).getTime() / 1000));
        const latestDate = Math.max.apply(null, dates);
        return new Date(latestDate * 1000);
    };
    const [anchorEl, setAnchorEl] = useState(null);
    const handleClick = (event: any) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };
    const [open, setOpen] = useState(false);
    const handleCloseDialog = (confirm: boolean) => {
        if (confirm) {
            deleteFolder(folder.folder_uid);
        }
        setOpen(false);
    };
    return (
        <tr
            key={folder.folder_uid}
            className={systemFolders.includes(folder.title) ? 'hidden' : 'show'}
        >
            <td className="filename">
                <i className="fas fa-folder"></i>{' '}
                <span onClick={() => onOpen(folder.folder_uid)}>
                    {folder.title}
                </span>
            </td>
            <td>{formatBytes(findSize())}</td>
            <td>{formatDate(findLastUpdated())}</td>
            <td>
                <ConfirmDialog
                    title={'Are you sure you wish to delete this folder?'}
                    text={''}
                    open={open}
                    cancelButtonText={'Cancel'}
                    confirmButtonText={'Confirm'}
                    handleClose={handleCloseDialog}
                />
                <Menu
                    id="simple-menu"
                    anchorEl={anchorEl}
                    keepMounted
                    open={Boolean(anchorEl)}
                    onClose={handleClose}
                >
                    <MenuItem onClick={() => openPropertiesViewer()}>
                        <i className="fas fa-info-circle" />
                    </MenuItem>
                    <MenuItem
                        onClick={() => {
                            onMove(folder.folder_uid);
                            handleClose();
                        }}
                    >
                        <i
                            className="fas fa-expand-arrows-alt"
                            style={{ cursor: 'pointer' }}
                        />
                    </MenuItem>
                    <MenuItem
                        onClick={() => {
                            zipFolder(folder.folder_uid);
                            handleClose();
                        }}
                    >
                        <i
                            className="fas fa-file-archive"
                            style={{ cursor: 'pointer' }}
                        />
                    </MenuItem>
                    <MenuItem
                        onClick={() => {
                            setOpen(true);
                            handleClose();
                        }}
                    >
                        <i
                            className="fas fa-trash-alt"
                            style={{ cursor: 'pointer' }}
                        />
                    </MenuItem>
                </Menu>
                <i
                    className="fas fa-ellipsis-h"
                    style={{ cursor: 'pointer' }}
                    onClick={handleClick}
                />
            </td>
        </tr>
    );
};

export default Folder;
